export const commonBook = {
  terms: '/terms',
  conversation: '/spiritual-ai',
  maintenance: '/maintenance',
  redirect: '/redirect', // INJECT
};
